import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ModalIaActivityDescriptionPage } from './modal-ia-activity-description.page';

const routes: Routes = [
  {
    path: '',
    component: ModalIaActivityDescriptionPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ModalIaActivityDescriptionPageRoutingModule {}
